import type { VoucherType } from './types'

export function getUsableOwnedVouchers(vouchers: VoucherType[] | undefined): VoucherType[] {
  return (vouchers ?? []).filter(voucher => voucher.isActive && voucher.canBeUsed)
}

export function hasBonusVoucher(vouchers: VoucherType[]): boolean {
  return vouchers.some(voucher => Boolean(voucher.bonusAmountLabel) || Boolean(voucher.bonusLabel))
}
